var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sorting"},[_c('native-sorting',{attrs:{"values":_vm.values||_vm.defaultValues,"init-value":_vm.checked},on:{"change":function($event){_vm.checked = $event; _vm.submit()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }